import Search from 'components/search-v2';
import TabsComponent from 'components/tabsComponent';
import utils from 'components/utilsComponent';
import TravelSwiper from 'components/travel-swiper';
import PopularResorts from 'components/popular-resorts';
import Swiper from 'vendor_components/swiper.min';

new Search(document.querySelector('.js-pageSearch'));

new TravelSwiper();
new PopularResorts(document.querySelector('.js-popularResorts'));

new TabsComponent({
    'container': '.js-kurortTabSwiper',
    'navigation': '.Selections__tab',
    'item': '.Resorts__content',
});

const $kurortTabSwiper = document.querySelector('.js-kurortTabSwiper');
if ($kurortTabSwiper) {
    const $element = $kurortTabSwiper.querySelector('.js-tabsSwiper');

    if ($element) {
        let swiper = new Swiper($element, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            navigation: {
                prevEl: $kurortTabSwiper.querySelector('.js-swiperArrowPrev'),
                nextEl: $kurortTabSwiper.querySelector('.js-swiperArrowNext'),
            },
        });

        setTimeout(() => {
            swiper.update();
        }, 500);
    }
}

utils.checkFavoriteList();
